setTimeout(function() {
    function adjustImageLayout() {
     var formEmbed = document.querySelector('form-embed');
     var section =  formEmbed.shadowRoot.querySelector('._inline_stahb_47');
      if (section) {
        var img = section.querySelector('.image__img2');
        if (window.location.pathname.includes('contact')) {
         var email__box = section.querySelector('.email__box');
        }
        section.style.backgroundColor = '#f2efeb'
        if (window.location.pathname.includes('contact')) {
         section.style.padding = '60px'
        }else{
         section.style.padding = '0px'
        }
        section.style.boxSizing = 'border-box'
        if (window.innerWidth <= 959) {
            if (img) {
                section.style.display = 'flex';
                section.style.justifyContent = 'space-around';
                section.style.flexDirection = 'column';
                section.style.alignItems = 'center';
                img.style.width = '100%'; // Adjust width to full width
                img.style.height = 'auto'; // Height auto to maintain aspect ratio
                img.style.objectFit = 'cover'; // Maintain aspect ratio
              if (window.location.pathname.includes('contact')) {
                email__box.style.marginBottom = '50px'; // Height auto to maintain aspect ratio
              }
              if(window.innerWidth <= 760){
                section.style.padding = '20px'
              }
            }
          } else {
              // Apply horizontal layout (default)
              if (img) {
                  section.style.display = 'grid';
                 if (window.location.pathname.includes('max-x-teaser-sign-up') || window.location.pathname.includes('wppi-sign-up-2025') || window.location.pathname.includes('bild-sign-up-2025')) {
                  section.style.gridTemplateColumns = '36% 60%';
                 }else{
                  section.style.gridTemplateColumns = '46% 46%';
                 }
                
                  section.style.justifyContent = 'space-around';
                 section.style.flexDirection = 'row';
                  section.style.alignItems = 'normal';
               
                  img.style.width = '100%'; // Default width
                 if (window.location.pathname.includes('contact')) {
                  img.style.height = '64%'; // Default height
                  section.style.padding = '0px';
                 }else{
                  img.style.height = '100%'; // Default height
                  section.style.padding = '20px';
                 }
                  img.style.objectFit = 'cover'; // Maintain aspect ratio
                  img.style.marginBottom = '0px'; // Height auto to maintain aspect ratio
                if (window.location.pathname.includes('contact')) {
                  email__box.style.marginBottom = '0px'; // Height auto to maintain aspect ratio
                }
                
              }
          }
      }
  }
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          var formEmbed = document.querySelector('form-embed');
          if (formEmbed && !formEmbed.dataset.processed) { 
              formEmbed.dataset.processed = true; 
              console.log('form-embed found:', formEmbed);
              observer.disconnect(); 
              var form = formEmbed.shadowRoot ? formEmbed.shadowRoot.querySelector('form') : formEmbed.querySelector('form');
                  if (form) {
                  if (window.location.pathname.includes('contact')) {
                    form.addEventListener('submit', function(event) {
                      event.preventDefault();
    
                      var outputs = form.querySelectorAll('output');
                      if (outputs.length === 0) {
                        const selectEl = formEmbed.shadowRoot.querySelectorAll('._selectToggleText_udw4q_25')[1];
                        const selectValue = selectEl.textContent;
                        console.log(selectValue, 'selectValue');
                        var formDataObj = {
                          username: formEmbed.shadowRoot.getElementById('last_name').value + ' ' + formEmbed.shadowRoot.getElementById('first_name').value,
                          email: formEmbed.shadowRoot.getElementById('email') ? formEmbed.shadowRoot.getElementById('email').value : '',
                          phone_number: formEmbed.shadowRoot.getElementById('phone_number') ? formEmbed.shadowRoot.getElementById('phone_number').value : '',
                          message:formEmbed.shadowRoot.querySelector('textarea')? formEmbed.shadowRoot.querySelector('textarea').value : '',
                          type:selectValue ? selectValue : ''
                        };
                        $.ajax({
                          url: 'https://portal.hobolite.com/v1/shopify/contact', // The server URL
                          type: 'POST', // HTTP method
                          data: formDataObj, // Data to be sent to the server
                          success: function(response) {
                            // Success logic here
                            // Optionally, reset the form
                            // location.reload()
                          },
                          error: function(xhr, status, error) {
                            // Error handling
                            // console.error('Error:', error);
                          }
                        });
                      } else {
                       
                      }
                    });
                   }
                  var section =  formEmbed.shadowRoot.querySelector('._inline_stahb_47');
                  if (section) {
                    // 创建一个 div 容器
                    var div = document.createElement('div');
                    div.className = 'image-container'; // 可选的 class 名称
  
                    
                    // 创建一个容器 div 包含地址和邮箱信息
                  var infoDiv = document.createElement('div');
                  infoDiv.style.display = 'flex';
                  infoDiv.style.flexDirection = 'column';
                  infoDiv.style.textAlign = 'left'; // 整体左对齐
                  infoDiv.style.justifyContent = 'start';
                  infoDiv.style.fontSize = '15px';
                  if (window.location.pathname.includes('contact')) {
                   infoDiv.style.marginTop = '60px'
                  }else{
                   infoDiv.style.marginTop = '0px'
                  }
                    
                    
                  // 创建地址部分
                  var addressDiv = document.createElement('div');
                  addressDiv.style.display = 'flex';
                  addressDiv.style.alignItems = 'start';
                  addressDiv.style.marginBottom = '6px';
                  addressDiv.style.marginTop = '20px';
                    
                  
                  // 地址图标
                  var addressIcon = document.createElement('img');
                  addressIcon.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/address.png?v=1730252811'; // 替换为地址图标的实际 URL
                  addressIcon.alt = 'Address Icon';
                    addressIcon.style.width = '16px';
                  addressIcon.style.marginRight = '5px';
                  addressIcon.style.marginTop = '6px';
                    
                  addressDiv.appendChild(addressIcon);
                  
                  // 地址文本
                  var addressLabel  = document.createElement('span');
                  addressLabel.innerHTML = "Address:";
                  addressLabel.style.marginRight = '10px';
                  addressDiv.appendChild(addressLabel);
  
                    // 地址文本
                  var addressText = document.createElement('span');
                  addressText.textContent = "100 N. La Salle St, Chicago, IL 60602";
                  addressDiv.appendChild(addressText);
                    
                  // 创建邮箱部分
                  var emailDiv = document.createElement('div');
                  emailDiv.style.display = 'flex';
                  emailDiv.style.alignItems = 'start';
                  emailDiv.className = 'email__box';
                    
                  
                  // 邮箱图标
                  var emailIcon = document.createElement('img');
                  emailIcon.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/email.png?v=1730252811'; // 替换为邮箱图标的实际 URL
                  emailIcon.alt = 'Email Icon';
                    emailIcon.style.width = '16px';
                  emailIcon.style.marginRight = '5px';
                  emailIcon.style.marginTop = '6px';
                  emailDiv.appendChild(emailIcon);
                  
                 var emailLabel = document.createElement('span');
                emailLabel.innerHTML = "Email:";
                emailLabel.style.marginRight = '10px';
                emailDiv.appendChild(emailLabel);
                // 邮箱内容（分成两行）
                var emailText = document.createElement('span');
                emailText.innerHTML = `
                  For PR inquiries please contact <strong>marketing@harlowe.com</strong>.<br>
                  For technical questions, please contact <strong>support@harlowe.com</strong>.
                `;
                emailDiv.appendChild(emailText);
                    
                    var img = document.createElement('img');
                    if (window.location.pathname.includes('subscribe')) {
                     img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/Hobolite_Iris_photography_lights_1080x1080_edc4593d-a3de-4da3-805d-cf67cb98324b.webp?v=1721706489';
                    }else if(window.location.pathname.includes('max-x-teaser-sign-up')){
                     img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/Max-x.webp?v=1736502836';
                    }else if(window.location.pathname.includes('maging-show-sign-up') || window.location.pathname.includes('wppi-sign-up-2025') || window.location.pathname.includes('bild-sign-up-2025')){
                     img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/Iris_homepage_photography_light.webp?v=1725254144';
                    }else if (window.location.pathname.includes('new-product-interest-form')) {
                      img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/c30e-4faf-9d0a-091664eaa0d1asd23.jpg?v=1745401584';
                    }else if (window.location.pathname.includes('bild-sign-up-form-2025')) {
                      img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/Mini-x_Iris.jpg?v=1748510231';
                    }else{
                     img.src = 'https://cdn.shopify.com/s/files/1/0635/2040/7793/files/SOL5_Mobile_light_1_f4730f05-c30e-4faf-9d0a-091664eaa0d1.jpg?v=1730275358';
                    }
                    img.alt = 'contact us lris';
                    img.style.width = '100%';
                    if (window.location.pathname.includes('contact')) {
                      img.style.height = '64%';
                      section.style.padding = '0px';
                      
                    }else{
                      img.style.height = '100%'; // Default height
                      section.style.padding = '20px';
                    }
                    img.style.objectFit = 'cover';
                    img.className = 'image__img2';
  
                      // 将地址和邮箱部分添加到 infoDiv 中
                  infoDiv.appendChild(img);
                 if (window.location.pathname.includes('contact')) {
                    infoDiv.appendChild(addressDiv);
                    infoDiv.appendChild(emailDiv);
                 }
                    section.insertBefore(infoDiv, section.firstChild);
                    
                        // Adjust layout on initial load
                    adjustImageLayout();
                    // Add event listener for window resize
                    window.addEventListener('resize', adjustImageLayout);
                  }
              }
          }
      });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}, 50);
